import tools from '../../../../assets/javascript/tools.js'
export default {
	columns: {
		memberName: {
			label: '姓名',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		mobile: {
			label: '联系方式',
			visible: true,
			width: 'auto',
			align: 'left',
		},

		cardName: {
			label: '套餐',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		leftCount: {
			label: '剩余次数',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		validEndTime: {
			label: '有效时间',
			visible: true,
			width: 'auto',
			formatDay: true,
			align: 'left',
		},
		validDay: {
			label: '离过期时间（天）',
			visible: true,
			width: 'auto',
			align: 'left',
		},
	},
	detail: {
		shopName: {
			label: '门店名称',
			visible: true,
			width: 'auto',
			align: 'left',
		},
		tradeDate: {
			label: '划卡时间',
			visible: true,
			width: '160',
			align: 'left',
		},
		tradeNum: {
			label: '划卡次数',
			visible: true,
			width: '80',
			align: 'right',
		},
	},
}
